import request from "@/utils/request";

export function getPage(condition, pagination) {
  return request({
    url: "/base/area/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/base/area/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/base/area/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/base/area/deleteById",
    method: "post",
    data: { id: id },
  });
}


export function exportExcel(condition, pagination) {
  return request({
    url: "/base/area/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}


